var de = require('./i18n/de');
var enUk = require('./i18n/uk-en');
var esEs = require('./i18n/es-es');
var frFr = require('./i18n/fr');
var frLu = require('./i18n/lu-fr');
var luNl = require('./i18n/lu-nl');
var nl = require('./i18n/nl');
var pl = require('./i18n/pl');
var beFr = require('./i18n/be-fr');
var beNl = require('./i18n/be-nl');
var esCat = require('./i18n/es-cat');
var it = require('./i18n/it');

var locales = {
  de: de,
  'es': esEs,
  'es-es': esEs,
  nl: nl,
  pl: pl,
  it: it,
  'es-cat': esCat,
  'lu-nl': luNl,
  'be-fr': beFr,
  'en-uk': enUk,
  'uk': enUk,
  'en': enUk,
  'fr-fr': frFr,
  'fr': frFr,
  'lu-fr': frLu,
  'be-nl': beNl,
}

module.exports = {
  load: function(locale) {
    if(locales[locale]) {
      return locales[locale];
    } else {
      return locales['fr-fr'];
    }
  }
};
